'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import Helmet from 'react-helmet'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _Media = require('./Media.css');

var _Media2 = _interopRequireDefault(_Media);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Media = (_dec = (0, _reactCssModules2.default)(_Media2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Media, _Component);

  function Media(props) {
    (0, _classCallCheck3.default)(this, Media);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Media.__proto__ || (0, _getPrototypeOf2.default)(Media)).call(this, props));

    _this.renderRelease = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'release' },
        _react2.default.createElement(
          'div',
          { styleName: 'release-title' },
          'Investors Demand Action from Hollywood on Smoking in Youth-Rated Films to Save 1,000,000 lives'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'release-subtitle' },
          _react2.default.createElement(
            'em',
            null,
            'Investors with $64 billion urge Hollywood studios to make youth-rated movies tobacco-free, as a new web-platform from As You Sow tracks investments in tobacco and entertainment companies that promote tobacco to kids'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'Oakland, CALIF \u2013 October 3, 2017 \u2013'
          ),
          ' A new website tracking mutual fund investments in companies responsible for kid\u2019s initiation to tobacco was released today by non-profit environmental health watchdog ',
          _react2.default.createElement(
            'em',
            null,
            'As You Sow'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'With tobacco-related illness the world\u2019s number one cause of preventable death, ',
          _react2.default.createElement(
            'em',
            null,
            'As You Sow'
          ),
          ' created ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: _config2.default.routes.home },
            'Tobacco Free Funds'
          ),
          ', a free online tool that allows investors for the first time ever to determine how their retirement savings are invested in tobacco and tobacco-promoting industries.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The platform analyzes mutual funds and ETFs for stock investments in both cigarette companies and entertainment companies that produce and distribute youth-rated films with imagery of tobacco. The Surgeon General and CDC report that smoking in youth-rated (G, PG, PG-13) films significantly increases the likelihood that youth will begin to smoke. This initiation often leads to a lifetime addiction and for many an early death. '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Tobacco Free Funds scores each mutual fund by measuring the fund\u2019s investments in tobacco companies and in entertainment companies that help recruit youth to smoke by failing to have strong policies against smoking in movies targeted toward children. It enables every person who owns shares of a mutual fund to see what they actually own and how they are profiting from the companies that perpetuate this health crisis.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The new tool comes as investor groups worth $64 billion ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: _config2.default.links.speakout },
            'published an open letter'
          ),
          ' to the movie studio\u2019s parent companies, calling for kid-rated movies to be smoke-free. The investors\u2019 recommendations align with an ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://www.aap.org/en-us/about-the-aap/aap-press-room/Pages/Leading-Health-Groups-Demand-Film-Industry-Give-R-Rating-to-Movies-That-Depict-Smoking.aspx', title: 'Leading Health Groups Demand Film Industry Give R Rating to Movies That Depict Smoking' },
            'open letter signed by major US health organizations'
          ),
          ' (representing 630,000 doctors) published a month ago. '
        ),
        _react2.default.createElement(
          'p',
          null,
          'Austin Wilson, Environmental Health Program Manager at As You Sow said, \u201CInvestments in tobacco are embedded in our pension funds, IRAs, and 401(k)s but most of us are not even aware of it. This free platform shows people if they own tobacco stocks, it allows them to find funds without tobacco, and helps them talk to their retirement plan administrators. It also educates investors about the role that Hollywood plays in youth smoking.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Stanton Glantz, Professor of Medicine at the University of California San Francisco and Director of the ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: _config2.default.links.ucsfSfm },
            'UCSF Smokefree Movies project'
          ),
          ' said, \u201CThere is no question that exposing children and adolescents to onscreen smoking in movies stimulates them to start smoking. There is a long well-documented history of collusion between the tobacco industry and Hollywood \u2013 it\u2019s time for the media companies to stop ignoring the science and stop promoting tobacco in media targeted at kids.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          'In 2012, the US Surgeon General produced ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://www.surgeongeneral.gov/library/reports/preventing-youth-tobacco-use/', title: 'Preventing Tobacco Use Among Youth and Young Adults: A Report of the Surgeon General, 2012' },
            'a landmark report'
          ),
          ' illustrating the impact of smoking in movies on children stating, \u201CThe evidence is sufficient to conclude that there is a causal relationship between depictions of smoking in the movies and the initiation of smoking among young people.\u201D In 2014 the Centers for Disease  Control and Prevention (CDC) also ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://www.cdc.gov/tobacco/data_statistics/fact_sheets/youth_data/movies/index.htm' },
            'condemned the practice'
          ),
          ', stating, \u201CGiving an R rating to future movies with smoking would be expected to reduce the number of teen smokers by nearly 1 in 5 (18%) and prevent one million deaths from smoking among children alive today.\u201D'
        ),
        _react2.default.createElement(
          'p',
          null,
          'In July 2017, the CDC again emphasized the issue when it reported in its ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://www.cdc.gov/mmwr/volumes/66/wr/mm6626a1.htm?s_cid=mm6626a1_w', title: 'Tobacco Use in Top-Grossing Movies — United States, 2010–2016' },
            _react2.default.createElement(
              'em',
              null,
              'Morbidity and Mortality Report'
            )
          ),
          ' that there had been substantial progress in eliminating smoking from youth-rated movies after 2005 which stopped in 2010. Had the prior trend continued, all youth-rated films would have been smokefree by 2015. Walt Disney is the only major movie studio that prohibits tobacco in movies it produces; Paramount, Universal, Warner Bros., Twentieth Century Fox, and Sony do not prohibit tobacco imagery. Overall, ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://www.nytimes.com/2017/07/17/well/family/why-smoking-in-films-harms-children.html?mcubz=0' },
            'about one in four youth-rated films included tobacco in 2016'
          ),
          ' according to UCSF\u2019s Center for Tobacco Control Research and Education.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Tobacco Free Funds also helps users speak out against entertainment companies with lax smoking policies, find tobacco free funds to invest in, and provides a toolkit to reform company 401(k)s. Over 2,000 U.S. open-end mutual funds and ETFs own tobacco stocks, with over $8 trillion dollars in assets under management. Among equity-based portfolios, two-thirds of all assets are invested in funds that own tobacco stocks.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'This is the third mutual fund transparency website from ',
          _react2.default.createElement(
            'em',
            null,
            'As You Sow'
          ),
          '. In 2015, ',
          _react2.default.createElement(
            'em',
            null,
            'As You Sow'
          ),
          ' launched ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: _config2.default.links.fff },
            'Fossil Free Funds'
          ),
          ' so that people could see if their retirement investments are funding climate change. In 2016, ',
          _react2.default.createElement(
            'em',
            null,
            'As You Sow'
          ),
          ' followed up with ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: _config2.default.links.dff },
            'Deforestation Free Funds'
          ),
          ', which screens funds for investments in deforestation-causing palm oil production.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'For more information, visit ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: _config2.default.routes.home },
            'TobaccoFreeFunds.org'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'strong',
            null,
            '# # #'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Expert contact: Austin Wilson (510) 735-8149, ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'mailto:awilson*asyousow.org?subject=Tobacco%20Free%20Funds&body=Replace%20asterisk%20in%20address%20to%20send' },
            'awilson@asyousow.org'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Communications contact: Cyrus Nemati (510) 735-8157, ',
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'mailto:cnemati*asyousow.org?subject=Tobacco%20Free%20Funds&body=Replace%20asterisk%20in%20address%20to%20send' },
            'cnemati@asyousow.org'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'em',
            null,
            _react2.default.createElement(
              _components.Link,
              { xstrong: true, to: _config2.default.links.ays },
              'As You Sow'
            ),
            ' is a nonprofit organization that promotes environmental and social corporate responsibility through shareholder advocacy, coalition building, and innovative legal strategies.'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            _components.Link,
            { xstrong: true, to: 'https://www.asyousow.org/wp-content/uploads/2017/10/Release_TobaccoFreeFunds_20171003-1.pdf' },
            'View this release as a PDF'
          )
        )
      );
    };

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Media, [{
    key: 'render',
    value: function render() {
      var title = 'Recent media releases';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _container2.default.helmet(title),
          _react2.default.createElement(
            'div',
            { styleName: 'snapshot' },
            _react2.default.createElement(
              'div',
              { styleName: 'snapshot-inner' },
              _react2.default.createElement(
                'h1',
                { styleName: 'title' },
                title
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'releases' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'releases-info' },
                  this.renderRelease()
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'contact' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'contact-title' },
                  'Get in touch'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'contact-info' },
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Media and General Inquiries'
                    )
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Andrew Montes, Director of Digital Strategies, As You Sow'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                      _components.Link,
                      { xstrong: true, styleName: 'contact', to: _config2.default.links.contact },
                      ' Email '
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Media;
}(_react.Component)) || _class);
exports.default = Media;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Media/Media.js
// module id = 1297
// module chunks = 0